/**
 * Constructs a stable, non-expiring profile picture URL.
 * ALWAYS routes through the backend proxy — never returns direct R2/S3 URLs
 * to avoid browser ORB (Opaque Response Blocking) issues.
 */
const API = process.env.REACT_APP_BACKEND_URL + '/api';

export function getProfilePicUrl(profilePicture, userId) {
  if (!profilePicture) return null;
  // If it's already a stable API path, return as-is
  if (profilePicture.startsWith('/api/')) return process.env.REACT_APP_BACKEND_URL + profilePicture;
  // If it's a full URL (R2 presigned URL, CDN URL, etc.) — ALWAYS proxy through backend
  if (profilePicture.startsWith('http')) {
    // Route through user ID proxy (most reliable)
    if (userId) return `${API}/users/${userId}/profile-picture`;
    // Extract filename from URL and route through filename proxy
    try {
      const urlPath = new URL(profilePicture).pathname;
      const filename = urlPath.split('/').pop();
      if (filename) return `${API}/profile/picture/${filename}`;
    } catch (e) {
      // URL parsing failed — try to extract filename from the end of the string
      const parts = profilePicture.split('/');
      const filename = parts[parts.length - 1]?.split('?')[0];
      if (filename) return `${API}/profile/picture/${filename}`;
    }
    // Last resort — still proxy even without filename extraction
    return null;
  }
  // Filename — construct stable API path
  return `${API}/profile/picture/${profilePicture}`;
}
